export function calculateBMI(height: number | null, weight: number | null): { bmi: number | null; category: string } {
  if (!height || !weight) return { bmi: null, category: 'Unknown' };
  
  // Convert height from cm to m and calculate BMI
  const heightInMeters = height / 100;
  const bmi = weight / (heightInMeters * heightInMeters);
  
  // BMI categories for children (using CDC standards)
  if (bmi >= 30) return { bmi, category: 'Obese' };
  if (bmi >= 25) return { bmi, category: 'Overweight' };
  if (bmi >= 18.5) return { bmi, category: 'Normal' };
  return { bmi, category: 'Underweight' };
}

export function adjustETTSizeForBMI(size: number, bmiCategory: string): number {
  if (bmiCategory === 'Obese') {
    return size - 0.5; // Reduce ETT size by 0.5mm for obese patients
  }
  return size;
} 